import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';


const Header: React.FC =  () =>{
    return(
        <header>
            <div>
            <nav className="navbar navbar-expand-sm bg-primary navbar-light">
                <h1 style={{color:"white", fontStyle:"oblique"}}>Currency Converter</h1>
            </nav>
            </div>
        </header>
        
    )
}

export default Header